'use client';

import { Icon } from '@iconify-icon/react';

const items = [
  {
    icon: 'tabler:lock-square-rounded',
    title: 'Encrypted at rest & in transit',
    body: 'AES-256 at rest · TLS 1.2+ in transit',
  },
  {
    icon: 'tabler:shield-check',
    title: 'GDPR & CCPA',
    body: 'Privacy-first data handling',
  },
  {
    icon: 'tabler:certificate',
    title: 'ISO/IEC 27001:2022',
    body: 'Certified · GCAI-ISMS-LM73',
  },
  {
    icon: 'tabler:users-group',
    title: 'Enterprise access control',
    body: 'RBAC · SSO · domain restriction',
  },
];

const TrustBar: React.FC = () => {
  return (
    <section aria-label="Security and compliance" className="bg-white pb-20 sm:pb-24">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[28px] bg-[#04182e] px-6 py-10 sm:px-12">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff07_1px,transparent_1px),linear-gradient(to_bottom,#ffffff07_1px,transparent_1px)] bg-[size:3rem_3rem]" />
            <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary-600/30 blur-[90px]" />
          </div>
          <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center">
            <div className="shrink-0 lg:max-w-[240px]">
              <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#ddb85a]/90">
                Built for trust
              </span>
              <p className="mt-2 font-display text-xl italic leading-snug text-white">
                Your knowledge stays yours.
              </p>
            </div>
            <div className="grid flex-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {items.map((item) => (
                <div key={item.title} className="flex items-start gap-3">
                  <Icon icon={item.icon} className="mt-0.5 text-xl text-[#d3a641]" />
                  <div>
                    <div className="text-sm font-semibold text-white">{item.title}</div>
                    <div className="mt-0.5 text-xs leading-relaxed text-blue-200/50">
                      {item.body}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
